import { UserRole } from '../../../api/users';
import { Button } from '../../../Components/Button/Button';
import { Filter } from '../../../Components/Filter/Filter';
import { Icons } from '../../../Components/Icons/Icons';
import { useAuth } from '../../../contexts/AuthContext';

interface MerchHeaderProps {
  agencyFilter: string;
  categoryFilter: string;
  onAgencyFilterChange: (value: string) => void;
  onCategoryFilterChange: (value: string) => void;
  onAddMerch: () => void;
  agencyOptions: Array<{ value: string; label: string }>;
  categoryOptions: Array<{ value: string; label: string }>;
}

export const MerchHeader = ({
  agencyFilter,
  categoryFilter,
  onAgencyFilterChange,
  onCategoryFilterChange,
  onAddMerch,
  agencyOptions,
  categoryOptions,
}: MerchHeaderProps) => {
  const { userData } = useAuth();

  return (
    <>
      <h1>
        Merch
        <a
          className="btn outline"
          target="_blank"
          href="https://app.smartsheet.com/b/form/2a6e5672f2ab4db9993ad10ef2d0d9bb"
          rel="noreferrer"
        >
          Submit a Request
        </a>
      </h1>
      <div className="page-header">
        <Filter
          hidden={false}
          filters={[
            {
              options: agencyOptions,
              value: agencyFilter,
              onChange: onAgencyFilterChange,
              placeholder: 'Agency',
            },
            {
              options: categoryOptions,
              value: categoryFilter,
              onChange: onCategoryFilterChange,
              placeholder: 'Category',
            },
          ]}
        />
        {userData?.role !== UserRole.USER && (
          <div className="btns">
            <Button variant="button" onClick={onAddMerch}>
              {Icons.WhitePlus} Add New Merch
            </Button>
          </div>
        )}
      </div>
    </>
  );
};
